import { Tabs, type Tab } from "shared/components/BaseTabs";

const TABS: Tab<"Credentials">[] = [
  { value: "Credentials", label: "Credentials" }
];

export const LockboxCredentialsTab = () => (
  <Tabs
    tabs={TABS}
    active="Credentials"
    onChange={() => undefined}
    tabStyle="line"
    size="md"
    fullWidthTabs={false}
  />
);
